export const modalErrorSelectors = {
  getModalError: (state) => state.modalError.error,
  getModalErrorPreventPageReload: (state) => state.modalError.preventPageReload,
  getModalErrorKeepPage: (state) => state.modalError.keepPage,
};
